import { privateRequest } from "../axios";
import type { ExportFileResult } from "@/types/common";
import { parseFilenameFromContentDisposition } from "@/lib/downloadExcel";
import type { EventType, EventLocation } from "./events";

const ENDPOINTS = {
  PAST_EVENTS: "/events/past",
};

export interface CreatePastEventPayload {
  name: string;
  description: string;
  cityId: number;
  eventDate: string;
  attended?: number;
  eventType?: string;
}

export interface PastEvent {
  id?: number;
  name?: string;
  description?: string;
  eventType?: EventType | string;
  type?: string;
  cityId?: number | null;
  cityName?: string;
  city?: string;
  cities?: string[] | null;
  locations?: EventLocation[] | null;
  eventDate?: string;
  date?: string;
  attended?: number | null;
  attendance?: number | string | null;
  capacity?: number | null;
  ticketPrice?: number | null;
  likesCount?: number;
  commentsCount?: number;
  flaggedCommentsCount?: number;
  thumbnailUrl?: string | null;
  coverImage?: string | null;
  [key: string]: unknown;
}

export interface PastEventsResponse {
  totalPublishedEvents?: number;
  totalLikesCount?: number;
  totalCommentsCount?: number;
  totalFlaggedComments?: number;
  totalRecord?: number;
  results?: PastEvent[];
}

export interface GetPastEventsParams {
  pageNo?: number;
  perPage?: number;
  isExport?: boolean;
}

export const getPastEvents = async (params?: GetPastEventsParams) => {
  try {
    const response = await privateRequest.get(ENDPOINTS.PAST_EVENTS, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching past events:", error);
    throw error;
  }
};

// Same `isExport: true`-returns-a-file convention as
// `services/api/auditLog.ts`'s `exportActionLogs` — see docs/decisions.md
// #74.
export const exportPastEvents = async (
  params?: Omit<GetPastEventsParams, "isExport">,
): Promise<ExportFileResult> => {
  const response = await privateRequest.get(ENDPOINTS.PAST_EVENTS, {
    params: { ...params, isExport: true },
    responseType: "blob",
  });
  return {
    blob: response.data as Blob,
    fileName: parseFilenameFromContentDisposition(response.headers["content-disposition"]),
  };
};

export const createPastEvent =async (payload: FormData) => {
  try {
    const response = await privateRequest.post(ENDPOINTS.PAST_EVENTS, payload);
    return response.data;
  } catch (error) {
    console.error("Error creating past event:", error);
    throw error;
  }
};